import { motion } from "framer-motion";

const SlideUpOnView = ({ children, delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }} // Reduced threshold and made it trigger only once
      transition={{ duration: 0.4, ease: "easeOut", delay }} // Reduced duration
      className="w-full"
    >
      {children}
    </motion.div>
  );
};

export default SlideUpOnView;
